export const RECENT_ADD_ITEM = "RECENT_ADD_ITEM";
export const RECENT_REMOVE_ITEM = "RECENT_REMOVE_ITEM";

export function addItem(item) {
    return {
        type: RECENT_ADD_ITEM,
        payload: {
            item: item,
        },
    };
}

export function removeItem(item) {
    return {
        type: RECENT_REMOVE_ITEM,
        payload: {
            item: item,
        },
    };
}
